export const OpenUrl = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M1.5 1.313a.188.188 0 0 0-.188.187v15c0 .104.084.188.188.188h15a.187.187 0 0 0 .188-.188v-5.025a.562.562 0 1 1 1.125 0V16.5c0 .725-.588 1.313-1.313 1.313h-15A1.312 1.312 0 0 1 .187 16.5v-15C.188.775.775.187 1.5.187h5.025a.563.563 0 0 1 0 1.125H1.5ZM10.912.75c0-.31.252-.563.563-.563h5.027c.726 0 1.31.59 1.31 1.313v1.313h-1.125V1.5a.186.186 0 0 0-.185-.188h-5.027a.562.562 0 0 1-.563-.562Zm5.775 2.063v3.712a.562.562 0 1 0 1.125 0V2.812h-1.125Z"
      clipRule="evenodd"
    />
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M16.898 1.102c.22.22.22.576 0 .796l-9.75 9.75a.562.562 0 1 1-.796-.796l9.75-9.75c.22-.22.576-.22.796 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export const ShareIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={22}
    viewBox="0 0 19 22"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M14.5 7.813a3.554 3.554 0 0 1-2.655-1.187L7.264 9.57c.192.438.298.921.298 1.43 0 .509-.106.992-.298 1.43l4.581 2.944a3.563 3.563 0 1 1-.61.946l-4.58-2.944a3.563 3.563 0 1 1 0-4.752l4.581-2.944A3.563 3.563 0 1 1 14.5 7.812ZM12.062 4.25a2.437 2.437 0 1 1 4.875 0 2.437 2.437 0 0 1-4.875 0Zm-5.99 8.034a.53.53 0 0 0-.044.069 2.437 2.437 0 1 1 .045-.07Zm6.355 4.184a2.437 2.437 0 1 0 4.147 2.564 2.437 2.437 0 0 0-4.148-2.564Z"
      clipRule="evenodd"
    />
  </svg>
);

export const DotsThreeLargeVertical = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4}
    height={17}
    viewBox="0 0 4 17"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      d="M3.25 2.23a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM2 9.594a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM2 16.02a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
    />
  </svg>
);
